import React, { Component } from "react";
import EuropeItems from "./EuropeItems";
import { Route, Switch } from "react-router-dom";
import ItemInfo from '../ItemInfo'
import europe from '../Europe'

export default class Europe extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    const europeData = europe.map(item => item)
    return (
      <React.Fragment>
        
        <Switch>
          <Route exact path="/europe" component={EuropeItems} />
          <Route path={europeData.link} component={ItemInfo}/>
        </Switch>
      </React.Fragment>
    );
  }
}
